// Films shown for a limited time (assets/videos/films.json; Seán, 2026-11-05): not in our Vimeo
// library, so added to the gallery's showcases by hand, at /Videos/<path> (Video/Film.vue). The
// preview's thumbnail stands in for the film's, and its description (with the bio) follows the
// film's intro, the acknowledgement last. Who may watch, and when: the fullstack (api/v1/videos/film/<key>).
import films from "@/assets/videos/films.json";

export const FILM_PATHS = Object.keys(films);
export const getFilm = (path) => films[path];

function getFilmVideo(film, preview) {
  const texts = [film.intro, preview?.description, film.acknowledgement];
  const description = texts.filter(Boolean).join("\n\n");
  const {name, tag, privacy, duration} = film;
  return {name, tag, privacy, duration, description, pictures: preview?.pictures};
}

// first in its showcase: a keynote, and the gallery's order (useVizbiOrder) keeps the order within
// a tag, so it leads the other keynotes (Seán, 2026-11-05)
export function addFilms(showcases) {
  for (const [path, film] of Object.entries(films)) {
    const showcase = showcases?.[film.showcase];
    if (!showcase?.videos) continue;
    const filmVideo = getFilmVideo(film, showcase.videos[film.preview]);
    showcase.videos = {[path]: filmVideo, ...showcase.videos};
  }
  return showcases;
}
